import { Inject } from '@odinjs/odin';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../../BaseController';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames } from '../../../codegen';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { NipsPainScaleAliases } from '../../../codegen/constants/aliases/nips-pain-scale-aliases';
import { Endpoint } from '../../../constants/endpoints';

@Controller({ fragment: FragmentNames.NIPS_PAIN_SCALE })
class NipsPainScaleController extends BaseController {

  @Inject(NipsPainScaleAliases.FACIAL_EXPRESSION_RG)
  facialExpressionRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.CRY_RG)
  cryRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.LEGS_RG)
  legsRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.BREATHING_RG)
  breathingRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.ARMS_RG)
  armsRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.ALERT_STATE_RG)
  alertStateRadioGroup!: RadioGroupAPI;

  @Inject(NipsPainScaleAliases.NIPS_REFERENCE_PANEL)
  referencePanel!: PanelAPI;

  @OnMount(NipsPainScaleAliases.FACIAL_EXPRESSION_RG)
  onMountFacialExpressionRadioGroup(): void {
    this.fetchPainScales(336083, this.facialExpressionRadioGroup);
  }

  @OnMount(NipsPainScaleAliases.CRY_RG)
  onMountCryRadioGroup(): void {
    this.fetchPainScales(336084, this.cryRadioGroup);
  }

  @OnMount(NipsPainScaleAliases.LEGS_RG)
  onMountLegsRadioGroup(): void {
    this.fetchPainScales(336085, this.legsRadioGroup);
  }

  @OnMount(NipsPainScaleAliases.BREATHING_RG)
  onMountBreathingRadioGroup(): void {
    this.fetchPainScales(336086, this.breathingRadioGroup);
  }

  @OnMount(NipsPainScaleAliases.ARMS_RG)
  onMountArmsRadioGroup(): void {
    this.fetchPainScales(336087, this.armsRadioGroup);
  }

  @OnMount(NipsPainScaleAliases.ALERT_STATE_RG)
  onmountAlertStateRadioGroup(): void {
    this.fetchPainScales(335983, this.alertStateRadioGroup);
  }

  @OnClose(NipsPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE)
  onCloseModal(): void {
    this.referencePanel.setVisible(false);
  }

  @OnClick(NipsPainScaleAliases.NIPS_REFERENCE_LINK)
  onClickReferenceLink(): void {
    this.referencePanel.setVisible(true);
  }

  @OnCancel(NipsPainScaleAliases.NIPS_SCALE_FORM)
  onCancelNipsForm(): void {
    ModalService.close(FragmentNames.NIPS_PAIN_SCALE);
  }

  @OnBeforeSubmit(NipsPainScaleAliases.NIPS_SCALE_FORM)
  onBeforeSubmit(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue')
    setPainScaleValue(Number(this.facialExpressionRadioGroup.getValue()?.value)
                      + Number(this.cryRadioGroup.getValue()?.value)
                      + Number(this.legsRadioGroup.getValue()?.value)
                      + Number(this.breathingRadioGroup.getValue()?.value)
                      + Number(this.armsRadioGroup.getValue()?.value)
                      + Number(this.alertStateRadioGroup.getValue()?.value));

    ModalService.close(FragmentNames.NIPS_PAIN_SCALE);
  }

  fetchPainScales(expressionId: number, radioGroup: RadioGroupAPI): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, { encounterId, expressionId, patientId })
      .then(response => {
        const responseBody = response.body as SelectableItem[];

        radioGroup.setValue(responseBody[0]);
        radioGroup.setData(responseBody);
      })
      .catch(console.error)
  }
}

export default NipsPainScaleController;
